import { render, staticRenderFns } from "./FavoritesBtn.vue?vue&type=template&id=dc59c704&scoped=true&"
import script from "./FavoritesBtn.vue?vue&type=script&lang=js&"
export * from "./FavoritesBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc59c704",
  null
  
)

export default component.exports